import React from 'react';
import styled from 'styled-components';

export default props => <C flex={props.flex} >{props.children}</C>

const C = styled.div`
    width:100%;
    max-width:1252px;
    margin: 0 auto;
    ${props => props.flex ? `
        display: flex;
    ` : ``}
    @media (max-width: 1252px) {
        padding: 0 25px;
    }
`


// WEBPACK FOOTER //
// ./src/partials/Container.js